import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';

import useIsPreviewMenuOn from 'hooks/useIsPreviewMenuOn';
import { formatDateTime } from 'bento-ordering/base/utils/timeHelpers';
import { getCurentLocationReopenStoreAtFieldSelector } from 'bento-ordering/locations/selectors';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';

export const NO_ORDER_ARE_BEING_ACCEPTED_AT_THIS_TIME =
  'No orders are being accepted at this time.';
export const ORDERING_REOPENS_ON = 'Ordering re-opens on';

const ItemDetailModalPreviewMenuMessage = () => {
  const isPreviewMenuOn = useIsPreviewMenuOn();
  const reopenStoreAt = useSelector(
    getCurentLocationReopenStoreAtFieldSelector
  );

  const getReOpenMessage = () => {
    let reOpenMessage = '';

    if (reopenStoreAt) {
      reOpenMessage = `${ORDERING_REOPENS_ON} ${formatDateTime(
        reopenStoreAt
      )}.`;
    } else {
      reOpenMessage = NO_ORDER_ARE_BEING_ACCEPTED_AT_THIS_TIME;
    }

    return reOpenMessage;
  };

  return (
    <>
      {isPreviewMenuOn ? (
        <Box mt={1}>
          <MenuItemDescriptionTypography component="p" variant="subtitle1">
            {getReOpenMessage()}
          </MenuItemDescriptionTypography>
        </Box>
      ) : null}
    </>
  );
};

export default ItemDetailModalPreviewMenuMessage;
